/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEvent } from './IntegrationEvent';
import {
    IntegrationEventFromJSON,
    IntegrationEventFromJSONTyped,
    IntegrationEventToJSON,
} from './IntegrationEvent';

/**
 * 
 * @export
 * @interface IntegrationEventResponse
 */
export interface IntegrationEventResponse {
    /**
     * 
     * @type {Array<IntegrationEvent>}
     * @memberof IntegrationEventResponse
     */
    data: Array<IntegrationEvent>;
    /**
     * 
     * @type {number}
     * @memberof IntegrationEventResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationEventResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationEventResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationEventResponse
     */
    has_next: boolean;
    /**
     * Facility-scoped leave destination resolved from the PccSyncV2LeaveOption setting (loa or hospitalized), so the UI can label the leave apply action ("Place on LOA" vs "Place on Hospitalized").
     * @type {string}
     * @memberof IntegrationEventResponse
     */
    leave_admission_status?: IntegrationEventResponseLeaveAdmissionStatusEnum;
}


/**
 * @export
 */
export const IntegrationEventResponseLeaveAdmissionStatusEnum = {
    Loa: 'loa',
    Hospitalized: 'hospitalized'
} as const;
export type IntegrationEventResponseLeaveAdmissionStatusEnum = typeof IntegrationEventResponseLeaveAdmissionStatusEnum[keyof typeof IntegrationEventResponseLeaveAdmissionStatusEnum];

/**
 * Check if a given object implements the IntegrationEventResponse interface.
 */
export function instanceOfIntegrationEventResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function IntegrationEventResponseFromJSON(json: any): IntegrationEventResponse {
    return IntegrationEventResponseFromJSONTyped(json, false);
}

export function IntegrationEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(IntegrationEventFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'leave_admission_status': !exists(json, 'leave_admission_status') ? undefined : json['leave_admission_status'],
    };
}

export function IntegrationEventResponseToJSON(value?: IntegrationEventResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(IntegrationEventToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
        'leave_admission_status': value.leave_admission_status,
    };
}
